import React from "react"

class NavItem extends React.Component {


    render() {
        return (
        <div 
            className={`stepItem ${this.props.currentStep === this.props.stepTitle ? 'stepItemActive' : ''}`}
            onClick={() => this.props.goToStep(this.props.stepTitle)}
        >
            {this.props.stepTitle}
        </div>)
    }
}

export default NavItem
